/* eslint-disable eqeqeq */
import { Button, DatePicker } from "antd";
import { zonedTimeToUtc } from "date-fns-tz";
import { Form, Formik } from "formik";
import { Select as FormikSelect, TimePicker } from "formik-antd";
import moment from "moment-timezone";
import { pathOr } from "ramda";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import { setPopup } from "../../../../actions/popupAction";
import CustomLabel from "../../../../components/customLabel";
import CustomModal from "../../../../components/customModal";
import {
  CONVO_TYPE,
  MOBILE_WIDTH,
  timezoneList,
} from "../../../../constants/constants";
import { getFormData, getFormattedMessage } from "../../../../helper/helpers";
import CommonService from "../../../../service/CommonService";
import loginService from "../../../../service/login";

import { Else, If, Then } from "react-if";
import Linkify from "react-linkify";
import { pauseIcon, playIcon } from "../../../../assets/svg";
import BottomBar from "../../../../components/bottomBar";
import useWindowDimensions from "../../../../components/custom-hooks/useWindowDimensions";
import CustomInput from "../../../../components/customInput";
import LoadingSpinner from "../../../../components/loadingSpinner";
import BroadcastUserService from "../../../../service/BroadcastUserService";
import "./styles.scss";

const AddEditSchedule = (props) => {
  const commonservice = new CommonService();
  const { Option } = FormikSelect;
  const {
    handleParentLoading,
    toggleScheduleDuplicationModal = () => {},
    disableSendSchedule = false,
  } = props;
  const dispatch = useDispatch();
  const sendScheduleRef = useRef(false);
  const broadcastService = new BroadcastUserService();

  const [scheduleState, setState] = useState({
    date: "",
    zone: "",
    errorMsgTime: "",
    zeroError: "",
    formInitialValues: {
      timeZone: "",
      scheduleDate: "",
      scheduleTime: "",
    },
    switchStatus: false,
    audioFileData: props?.msgValues?.audio,
    audioStatus: "Play",
    submitLoader: false,
    previewText: "",
    loading: false,
    isDuplicatedEntry: false,
    showDuplicationEntryModal: false,
  });

  const { width } = useWindowDimensions();

  const { edit, headers = {}, data } = props;
  const [disabled, setDisabledState] = useState(false);

  const getScheduleData = async () => {
    try {
      const response = await commonservice.getScheduleById(
        props.values.broadcastTransactionId
      );

      const timezone = getTimeZone(response.timezone);

      setState((st) => ({
        ...st,
        date: moment(response.scheduleDate),
        formInitialValues: {
          timeZone: timezone,
          scheduleDate: moment(response.scheduleDate, "MM/DD/YYYY"),
          scheduleTime: moment(response.scheduleTime, "HH:mm"),
        },
      }));
    } catch (err) {
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: pathOr(
            "Something went wrong",
            ["response", "data", "message"],
            err
          ),
        })
      );
    }
  };

  const getTimeZone = (timezone) => {
    if (timezone === "cst" || timezone === "cdt") {
      setState((st) => ({ ...st, zone: "America/Chicago" }));
      return "US/Central";
    }
    if (timezone === "est" || timezone === "edt") {
      setState((st) => ({ ...st, zone: "America/Montreal" }));
      return "US/Eastern";
    }
    if (timezone === "mst" || timezone === "mdt") {
      setState((st) => ({ ...st, zone: "America/Denver" }));
      return "US/Mountain";
    }
    if (timezone === "pst" || timezone === "pdt") {
      setState((st) => ({ ...st, zone: "America/Los_Angeles" }));
      return "US/Pacific";
    }
    if (timezone === "arizona-mst") {
      setState((st) => ({ ...st, zone: "US/Arizona" }));
      return "US/Arizona";
    }
    if (timezone === "akst" || timezone === "akdt") {
      setState((st) => ({ ...st, zone: "US/Alaska" }));
      return "US/Alaska";
    }
    if (timezone === "hst" || timezone === "hdt") {
      setState((st) => ({ ...st, zone: "US/Hawaii" }));
      return "US/Hawaii";
    }
  };

  useEffect(() => {
    if (edit) {
      getScheduleData();
    }
  }, []);

  useEffect(
    () => {
      moment.tz.setDefault(scheduleState.zone);
    },
    [scheduleState.zone]
  );

  const addSchedule = async (values) => {
    setState((st) => ({ ...st, showDuplicationEntryModal: false }));
    handleParentLoading(true);
    if (sendScheduleRef && sendScheduleRef.current) return;
    else {
      try {
        setState((st) => ({
          ...st,
          loading: true,
          submitLoader: true,
        }));
        sendScheduleRef.current = true;
        const practiceId = loginService.getPracticeId();
        const scheduledDate = values?.scheduleDate;
        const scheduledTime = moment(values.scheduleTime).format("HH:mm");
        const {
          broadcastIds,
          fileId,
          userType,
          selectedCount,
          selectAll,
          filter,
          unselectedIds,
          message,
          filename,
          isMultiLang,
        } = props.getScheduledMsgData(props.msgValues);
        await broadcastService.messageLogs({
          message: message?.message || message.rcsMessage,
          fileId,
          filename,
          ...(message.convoType === CONVO_TYPE.RCS && {
            templateId: message.rcsTemplateId,
          }),
        });
        const scheduleData = {
          practiceId,
          message: props.formatMessageValues(message),
          isMultiLang,
          translationObject:
            message?.translationObject || props?.msgValues?.translationObject || {},
          emailSubject: message.emailSubject,
          emailColumn: message.emailColumn,
          emailTemplateId: message.emailTemplateId,
          broadcastIds,
          fileId,
          userType,
          convoType: message.convoType,
          selectedCount,
          selectAll,
          filter,
          unselectedIds,
          templateId: message.template,
          ivrMessage: message.ivrMessage,
          ivrTemplate: message.ivrTemplate,
          useSmsForIVR: message.useSmsForIVR,
          optOutMessage: message.optOutMessage,
          optOutTemplate: message.optOutTemplate,
          enableOptOut: message.enableOptOut,
          responseTemplate: message.responseTemplate,
          responseMessage: message.responseMessage,
          type: "onDemand-Sched",
          scheduledDate,
          scheduledTime,
          timeZoneString: values.timeZone,
          subtype:
            message.convoType === "ivr" && message.subtype ? "audio" : "text",
          isTwilioDisabled:
            localStorage.getItem("isTwilioDisabled") !== null &&
            localStorage.getItem("isTwilioDisabled") === "true",
          countryCodeForRcs: localStorage.getItem("countryCodeForRcs") || "",
        };
        const payloadData = {
          body: JSON.stringify(scheduleData),
          audio: message.audio,
        };
        const formData = getFormData(payloadData);
        setState((st) => ({
          ...st,
          scheduleLoader: true,
        }));
        setDisabledState(true);
        const response = await commonservice.saveBroadcastSchedule(formData);
        props.handleParentLoading();
        props.hideScheduleModal();
        props.typeLabel === "Employees" &&
          (await props.getEmployeeSendAnotherMsg(fileId));
        setState((st) => ({
          ...st,
          scheduleLoader: false,
          loading: false,
          submitLoader: false,
        }));
        setDisabledState(false);
        dispatch(
          setPopup({
            customPopupMessage: true,
            messageType: "success",
            message:
              width > MOBILE_WIDTH
                ? pathOr("Something went wrong", ["data", "message"], response)
                : response?.data?.message
                  ? "Broadcast successfull"
                  : "",
          })
        );
        props.showBroadcastResend();
        sendScheduleRef.current = false;
      } catch (err) {
        dispatch(
          setPopup({
            customPopupMessage: true,
            messageType: "error",
            message: pathOr(
              "Something went wrong",
              ["response", "data", "message"],
              err
            ),
          })
        );
        setState((st) => ({
          ...st,
          scheduleLoader: false,
          loading: false,
          submitLoader: false,
        }));
        props.hideScheduleModal();
        setDisabledState(false);
        sendScheduleRef.current = false;
      } finally {
        handleParentLoading(false);
      }
    }
  };

  const newBroadcastMob = (values) => {
    if (!scheduleState.switchStatus) {
      props.onSubmit();
      return;
    } else {
      toggleScheduleDuplicationModal(values, addSchedule);
    }
  };

  const updateSchedule = async (values) => {
    try {
      setState((st) => ({
        ...st,
        loading: true,
      }));
      const scheduledDate = moment(values.scheduleDate).format("MM/DD/YYYY");
      const scheduledTime = moment(values.scheduleTime).format("HH:mm");
      const scheduleData = {
        transactionId: props.values.broadcastTransactionId.toString(),
        scheduledDate,
        scheduledTime,
        timeZoneString: values.timeZone,
        countryCodeForRcs: localStorage.getItem("countryCodeForRcs") || "",
      };
      const response = await commonservice.updateBroadcastSchedule(
        scheduleData
      );
      setState((st) => ({
        ...st,
        loading: false,
      }));

      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "success",
          message: pathOr(
            "Something went wrong",
            ["data", "message"],
            response
          ),
        })
      );
      props.hideScheduleModal();
    } catch (err) {
      setState((st) => ({
        ...st,
        loading: false,
      }));
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: pathOr(
            "Something went wrong",
            ["response", "data", "message"],
            err
          ),
        })
      );
      props.hideScheduleModal();
    }
  };

  const handlePlayPause = (value) => {
    if (value === "Play") {
      props.audioRef.current.play();
      setState((st) => ({
        ...st,
        audioStatus: "Pause",
      }));
    } else {
      props.audioRef.current.pause();
      setState((st) => ({
        ...st,
        audioStatus: "Play",
      }));
    }
  };

  useEffect(
    () => {
      if (width < MOBILE_WIDTH && !edit) {
        const formattedMessage = getFormattedMessage(
          props?.msgValues?.message || "",
          data,
          headers
        );
        setState((st) => ({ ...st, previewText: formattedMessage }));
      }
    },
    [props?.msgValues?.message, data, headers]
  );

  return (
    <Formik enableReinitialize initialValues={scheduleState.formInitialValues}>
      {({ values, dirty, setFieldValue, handleReset }) => {
        const disablePastDt = (current) => {
          const cal_date = current.format("YYYY-MM-DD");
          const currentTz = zonedTimeToUtc(cal_date, scheduleState.zone);
          return (
            (currentTz &&
              moment(currentTz).startOf("day") < moment().startOf("day")) ||
            currentTz >
              moment()
                .add(7, "day")
                .endOf("day")
          );
        };

        const disableHrs = () => {
          var selectedDt = moment(scheduleState.date).date();
          var hours = [];
          var hourLimit = moment().hour();
          if (moment().minute() >= 55) {
            hourLimit += 1;
          }
          if (selectedDt === moment().date()) {
            for (var i = 0; i < hourLimit; i++) {
              hours.push(i);
            }
            return hours;
          }
        };

        const disableMins = (selectedHour) => {
          var selectedDt = moment(scheduleState.date).date();
          var minutes = [];
          if (selectedDt === moment().date()) {
            if (selectedHour === moment().hour()) {
              for (var i = 0; i < moment().minute(); i++) {
                minutes.push(i);
              }
            }
          }
          return minutes;
        };

        const checkPastTime = (value) => {
          const selectedDt = moment(value).date();
          const currentDt = moment().date();
          if (selectedDt === currentDt) {
            const endTime = moment("2330", "hmm").format("HH:mm");
            if (moment().format("HH:mm") > endTime) {
              setState((st) => ({
                ...st,
                errorMsgTime: "No time slots available for the selected date",
              }));
            }
          } else {
            setState((st) => ({
              ...st,
              errorMsgTime: "",
            }));
          }
        };

        const checkZeros = (value) => {
          const currentDt = moment().format("DD-MM-YYYY");
          const currentTime = moment().format("HH:mm");
          const selectedDay = moment(values.scheduleDate).format("DD-MM-YYYY");
          const selectedTime = moment(value).format("HH:mm");

          if (selectedDay === currentDt) {
            if (currentTime > selectedTime) {
              setState((st) => ({
                ...st,
                zeroError: "This time slot is not available!",
              }));
            } else {
              setState((st) => ({
                ...st,
                zeroError: "",
              }));
            }
          }
        };
        const checkDisabledStatus = () => {
          if (disableSendSchedule) {
            return true;
          }
          const result = !scheduleState.switchStatus
            ? false
            : values.timeZone &&
              values.scheduleDate &&
              values.scheduleTime &&
              !scheduleState.zeroError &&
              !scheduleState.errorMsgTime &&
              dirty
              ? false
              : true;
          return result;
        };
        return (
          <>
            {!edit &&
              !props.showDuplicateEntryModal &&
              !props.sendMessageState && (
                <div className="bottom-bar">
                  <BottomBar
                    handleBackButton={props.prevPage}
                    handleNextButton={() => {
                      edit ? updateSchedule(values) : newBroadcastMob(values);
                    }}
                    disabled={checkDisabledStatus()}
                    forwardBtnText="Send Broadcast"
                  />
                </div>
              )}
            <Form className="fields-wrapper">
              {(width > MOBILE_WIDTH || edit) && (
                <CustomModal
                  title={props.title}
                  submitButtonText={edit ? "Save Changes" : "Send Schedule"}
                  cancelButtonText="Cancel"
                  isVisible={props.isVisible}
                  customClass="schedule-modal"
                  handleCancel={() => {
                    handleReset();
                    props.hideScheduleModal();
                  }}
                  handleDelete={() => {
                    edit
                      ? updateSchedule(values)
                      : toggleScheduleDuplicationModal(values, addSchedule);
                  }}
                  loading={scheduleState.loading}
                  disabled={
                    disableSendSchedule ||
                    values.timeZone &&
                    values.scheduleDate &&
                    values.scheduleTime &&
                    !scheduleState.zeroError &&
                    !scheduleState.errorMsgTime &&
                    dirty
                      ? false
                      : true
                  }
                >
                  <div className="modal-fields-wrapper">
                    <div className="modal-form-row ml-16">
                      <CustomLabel title="Timezone" />
                      <section
                        className={`form-row with-mutli-select ${
                          width > MOBILE_WIDTH ? "ml-8" : ""
                        }`}
                      >
                        <FormikSelect
                          name="timeZone"
                          className={`common-select-field ${
                            width > MOBILE_WIDTH ? "ml-16" : ""
                          }`}
                          placeholder="Select Timezone"
                          getPopupContainer={(trigger) => trigger.parentNode}
                          style={{ width: width > MOBILE_WIDTH ? 328 : 200 }}
                          onChange={(value) => {
                            setFieldValue("timeZone", value);
                            setFieldValue("scheduleDate", "");
                            setFieldValue("scheduleTime", "");
                            setState((st) => ({
                              ...st,
                              zone: value,
                              errorMsgTime: "",
                              zeroError: "",
                            }));
                          }}
                        >
                          {timezoneList.map((item) => (
                            <Option key={item.value} value={item.value}>
                              {item.name}
                            </Option>
                          ))}
                        </FormikSelect>
                      </section>
                    </div>

                    <section
                      className={`modal-form-row mt-16 mb-8 ${
                        width > MOBILE_WIDTH ? "ml-16" : ""
                      }`}
                    >
                      <CustomLabel title="Date & Time" />
                      <div className={width > MOBILE_WIDTH ? "ml-16" : ""}>
                        <DatePicker
                          format="MM/DD/YYYY"
                          disabled={values.timeZone ? false : true}
                          className={`common-date-time ${
                            scheduleState.errorMsgTime ? "error-box" : ""
                          }`}
                          onChange={(value) => {
                            setFieldValue("scheduleDate", value);
                            setFieldValue("scheduleTime", "");
                            setState((st) => ({
                              ...st,
                              date: value,
                              zeroError: "",
                            }));
                            checkPastTime(value);
                          }}
                          placeholder="Select Date"
                          name="scheduleDate"
                          disabledDate={disablePastDt}
                          value={
                            values.scheduleDate &&
                            moment(values.scheduleDate, "MM/DD/YYYY")
                          }
                          style={{ width: 160 }}
                        />

                        <TimePicker
                          disabled={
                            values.timeZone &&
                            values.scheduleDate &&
                            !scheduleState.errorMsgTime
                              ? false
                              : true
                          }
                          getPopupContainer={(trigger) => trigger.parentNode}
                          className={`common-date-time ${
                            width > MOBILE_WIDTH ? "ml-8" : "mt-16"
                          } `}
                          placeholder="Select Time"
                          name="scheduleTime"
                          onSelect={(value) => {
                            setFieldValue("scheduleTime", value);
                            checkZeros(value);
                          }}
                          style={{ width: 160 }}
                          minuteStep={5}
                          format="HH:mm"
                          showNow={false}
                          disabledHours={disableHrs}
                          disabledMinutes={disableMins}
                          value={values.scheduleTime}
                        />
                      </div>
                      {scheduleState.errorMsgTime || scheduleState.zeroError ? (
                        <div className="error-text">
                          {scheduleState.errorMsgTime ||
                            scheduleState.zeroError}
                        </div>
                      ) : null}
                    </section>
                  </div>
                </CustomModal>
              )}
              {width < MOBILE_WIDTH &&
                !edit && (
                  <>
                    {scheduleState.submitLoader && (
                      <div className="display-in-mob">
                        <LoadingSpinner
                          customClassName="broadcast"
                          type="large"
                        />
                      </div>
                    )}
                    <div className="mobile-review-container">
                      <h2 className="mobile-title">Review Broadcast Details</h2>
                      <span className="mobile-sub-heading">
                        Review your details and initiate broadcast
                      </span>
                      <div className="section">
                        <span className="type">Message Type </span>
                        {!props?.msgValues?.subtype && (
                          <span className="selected-name">
                            {props?.msgValues?.convoType.toUpperCase()}
                          </span>
                        )}
                        {props?.msgValues?.subtype && (
                          <span className="selected-name">IVR Audio</span>
                        )}
                        {props?.msgValues?.convoType === "email" ? (
                          <div className="email">
                            <div className="type">Email Subject </div>
                            <div>{props?.msgValues?.emailSubject}</div>
                          </div>
                        ) : (
                          <div className="outer-box">
                            <div className="inner-box label">
                              {!props?.msgValues?.subtype ? (
                                <div className="preview-message-container">
                                  <div
                                    className={`content ${scheduleState.previewText &&
                                      "preview-content"}`}
                                  >
                                    <If condition={scheduleState.previewText}>
                                      <Then>
                                        <>
                                          <div className="text">
                                            <Linkify>
                                              {scheduleState.previewText}
                                            </Linkify>
                                            {props?.msgValues
                                              ?.optOutMessage && (
                                              <div>
                                                <br />
                                                {
                                                  props?.msgValues
                                                    ?.optOutMessage
                                                }
                                              </div>
                                            )}
                                          </div>
                                        </>
                                      </Then>

                                      <Else>
                                        <div className="empty-text">
                                          Response message preview will show up
                                          here
                                        </div>
                                      </Else>
                                    </If>
                                  </div>
                                </div>
                              ) : (
                                <section className="send-message-with-variables-wrapper">
                                  <div className={`send-message-container`}>
                                    {scheduleState.audioFileData.size > 0 ? (
                                      <section className="audio-file-container">
                                        <Button
                                          className="audio-file"
                                          onClick={() =>
                                            handlePlayPause(
                                              scheduleState.audioStatus
                                            )
                                          }
                                        >
                                          <span className="icon">
                                            {scheduleState.audioStatus ===
                                            "Play"
                                              ? playIcon
                                              : pauseIcon}
                                          </span>

                                          <span
                                            className="file-name"
                                            title={
                                              scheduleState?.audioFileData?.name
                                            }
                                          >
                                            {scheduleState?.audioFileData?.name}
                                          </span>
                                        </Button>
                                      </section>
                                    ) : null}
                                  </div>
                                </section>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="section">
                        <h2 className="type margin-bottom-2">
                          Message Schedule
                        </h2>
                        <div className="inner-box padding-2 margin-bottom-2">
                          <CustomInput
                            type="switch"
                            pretext="Send Now"
                            posttext="Schedule Later"
                            name="messageType"
                            active={scheduleState.switchStatus.toString()}
                            required
                            onChange={(value) => {
                              setState((st) => ({
                                ...st,
                                switchStatus: value,
                              }));
                            }}
                          />
                        </div>
                        {scheduleState.switchStatus && (
                          <div>
                            <h2 className="type margin-bottom-2">
                              Schedule Broadcast
                            </h2>
                            <section className="margin-bottom-2">
                              <FormikSelect
                                name="timeZone"
                                className="common-select-field ml-16"
                                placeholder="Select Timezone"
                                getPopupContainer={(trigger) =>
                                  trigger.parentNode
                                }
                                onChange={(value) => {
                                  setFieldValue("timeZone", value);
                                  setFieldValue("scheduleDate", "");
                                  setFieldValue("scheduleTime", "");
                                  setState((st) => ({
                                    ...st,
                                    zone: value,
                                    errorMsgTime: "",
                                    zeroError: "",
                                  }));
                                }}
                              >
                                {timezoneList.map((item) => (
                                  <Option key={item.value} value={item.value}>
                                    {item.name}
                                  </Option>
                                ))}
                              </FormikSelect>
                            </section>
                            <h2 className="type margin-bottom-2 margin-top-2">
                              Date & Time
                            </h2>
                            <div className="mob-date-pickers">
                              <DatePicker
                                format="MM/DD/YYYY"
                                disabled={values.timeZone ? false : true}
                                className={`mob-date-time ${
                                  scheduleState.errorMsgTime ? "error-box" : ""
                                }`}
                                onChange={(value) => {
                                  setFieldValue("scheduleDate", value);
                                  setFieldValue("scheduleTime", "");
                                  setState((st) => ({
                                    ...st,
                                    date: value,
                                    zeroError: "",
                                  }));
                                  checkPastTime(value);
                                }}
                                placeholder="Select Date"
                                name="scheduleDate"
                                disabledDate={disablePastDt}
                                value={
                                  values.scheduleDate &&
                                  moment(values.scheduleDate, "MM/DD/YYYY")
                                }
                              />

                              <TimePicker
                                disabled={
                                  values.timeZone &&
                                  values.scheduleDate &&
                                  !scheduleState.errorMsgTime
                                    ? false
                                    : true
                                }
                                getPopupContainer={(trigger) =>
                                  trigger.parentNode
                                }
                                className="mob-date-time"
                                placeholder="Select Time"
                                name="scheduleTime"
                                onSelect={(value) => {
                                  setFieldValue("scheduleTime", value);
                                  checkZeros(value);
                                }}
                                minuteStep={5}
                                format="HH:mm"
                                showNow={false}
                                disabledHours={disableHrs}
                                disabledMinutes={disableMins}
                                value={values.scheduleTime}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default AddEditSchedule;
